var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"HeaderImgBox"},[(_vm.imgUrl)?_c('img',{attrs:{"src":_vm.imgUrl}}):_c('img',{attrs:{"src":require("@/assets/images/user/defaultHeaderImg.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }